module.exports = __webpack_public_path__ + "static/media/inviteportal.e2450600.svg";